/**
 * Utility to check if a symbol supports visual chart views (play and candle)
 * This allows for easy addition of new symbols when they are enabled.
 */

// List of symbols that support visual chart views
const VISUAL_SUPPORTED_SYMBOLS = [
    'EURUSD',
];

/**
 * Check if a symbol supports visual chart views
 * @param {string} symbol - The trading symbol (e.g., 'EURUSD')
 * @returns {boolean} - True if the symbol supports visual views, false otherwise
 */
export function isSymbolVisualSupported(symbol) {
    if (!symbol || typeof symbol !== 'string') {
        return false;
    }
    
    return VISUAL_SUPPORTED_SYMBOLS.includes(symbol.toUpperCase());
}

/**
 * Get the list of all supported symbols for visual views
 * @returns {string[]} - Array of supported symbol strings
 */
export function getSupportedVisualSymbols() {
    return [...VISUAL_SUPPORTED_SYMBOLS];
}

/**
 * Add a new symbol to the supported list (for future use)
 * @param {string} symbol - The symbol to add
 */
export function addSupportedSymbol(symbol) {
    if (symbol && typeof symbol === 'string') {
        const upperSymbol = symbol.toUpperCase();
        if (!VISUAL_SUPPORTED_SYMBOLS.includes(upperSymbol)) {
            VISUAL_SUPPORTED_SYMBOLS.push(upperSymbol);
        }
    }
}
